import { DoorIcon } from '@fronton/icons-react';
import { DesignRegistrationPanelStructure } from 'common/components/design-registration-panel';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../entrance-doors-constants';

export const ENTRANCE_DOORS_PANEL_STRUCTURE: DesignRegistrationPanelStructure = {
  panel: {
    content: {
      leftIcon: DoorIcon,
      iconColor: 'text-invert',
      iconType: 'duotone',
      text: 'Запишитесь на бесплатную консультацию\u00A0и\u00A0замер',
    },
    actionBlock: [],
  },
  mobilePanel: {
    mobileButton: {
      label: 'Записаться на консультацию',
      elementBlock: ENTRANCE_DOORS_ELEMENT_BLOCK,
    },
    content: {
      icon: DoorIcon,
      iconColor: 'text-invert',
      iconType: 'duotone',
      text: 'Запишитесь на бесплатную консультацию\u00A0и\u00A0замер',
    },
    actionBlock: [],
  },
};
